<template>
  <v-container ref="market"  fluid class="market-container pa-3">
    <v-row no-gutters>
      <v-col
        xs="0"
        sm="0"
        md="0"
        lg="1"
        xl="1"
      >
      </v-col>

      <v-col
        xs="12"
        sm="12"
        md="12"
        lg="10"
        xl="10"
      ><!-- title OMITTED
        <div class="d-flex mb-7">
       
          <div 
            class="text-h3 font-weight-light" 
            style="
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
            "
          >
            {{ $t('title.marketMonitor') }}
          </div>
          <v-spacer></v-spacer>
          <div class="font-weight-light">
     
          </div>
        </div>
      -->
      </v-col>
    </v-row>
    <!--first row-->
    <v-row
      no-gutters
      md="8"
      class="bottom-border"
    >
      <!-- Temporary removal of Dollar Radar -->
      <v-col
        v-if="false"
        xs="12"
        sm="12"
        md="12"
        lg="4"
        xl="4"
        class="mb-8"
      >
        <v-row class="align-center">
          <v-col cols="12">
            <v-sheet
              color="transparent"
              class="d-flex flex-column align-center justify-center"
            >
              <div class="d-flex align-center py-6 px-8" style="width: 100%">
                <div class="text--secondary text-h5 font-weight-bold mr-8">
                  {{ $t('marketMonitor.dollarRadar.title') }}
                </div>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="0"
                  class="disable-focus"
                  rounded
                  fab
                  small
                  color="primaryTransp"
                  @click="fetchDollarRadar()"
                  :loading="loadingFetchDollar"
                  :retain-focus-on-click="false"
                >
                  <v-icon color="primary">
                    mdi-refresh
                  </v-icon>
                </v-btn>
              </div>
              <div class="px-8" style="width: 100%">
                <v-divider></v-divider>
              </div>
              <div class="py-6 px-8 d-flex align-center" style="width: 100%">
                <div class="mr-2">
                  {{ $t('marketMonitor.period.title') }}: 
                </div>
                <v-chip-group
                  v-model="selectedDollarPeriod"
                  mandatory
                  column
                >
                  <v-chip
                    v-for="(dollarPeriod, index) in dollarPeriods"
                    class="text-caption font-weight-black"
                    color="#212121"
                    text-color="#BDBDBD"
                    active-class="primaryTransp primary--text"
                    :key="index"
                    :value="dollarPeriod"
                    :disabled="dollarPeriod.disabled"
                  >
                    {{ dollarPeriod.text }}
                  </v-chip>
                </v-chip-group>
              </div>
              <div class="px-8" style="width: 100%">
                <v-divider></v-divider>
              </div>
              <!-- Dollar Today -->
              <div class="d-flex py-6 px-8 justify-center" style="width: 100%">
                <div class="mx-4 d-flex flex-column">
                  <div class="d-flex justify-center text-body-1 text--secondary"> 
                      <span>
                        {{ $t('marketMonitor.dollar') }}
                      </span>
                      &nbsp;
                      <span class="font-weight-bold"> 
                        {{ $t('timestamp.today') }}
                      </span> 
                  </div>
                  <div class="d-flex align-center" style="margin-left: -82px">
                    <v-icon style="font-size: 58px" color="#424242">
                      mdi-calendar-today
                    </v-icon>
                    &nbsp;
                    <div class="text-h4 ml-4 font-weight-bold">
                      {{ dollarByPeriod.dollar_today }}
                    </div>
                    </div>
                </div>
              </div>
              <!-- Dollar Trend -->
              <div 
                v-if="dollarByPeriod.dollar_trend.toLocaleLowerCase().includes('strong')"
                class="d-flex pb-6 pt-0 px-8 align-center justify-center" 
                style="width: 100%"
              >
                <div class="mx-4 d-flex flex-column">
                  <div class="d-flex justify-center text-body-1 text--secondary">
                    <span> 
                      {{ $t('marketMonitor.dollar') }}
                    </span>
                    &nbsp;
                    <span class="font-weight-bold">
                        {{ $t('marketMonitor.trend') }}
                    </span>
                  </div>
                  <div class="d-flex align-center" style="margin-left: -82px">
                    <v-icon style="font-size: 58px" color="primary">
                      {{ dollarByPeriod.dollar_trend | trendIcon }}
                    </v-icon>
                    &nbsp;
                    <div class="text-h4 ml-4 font-weight-bold">
                      {{ trendLabel(dollarByPeriod.dollar_trend) }}
                    </div>
                  </div>
                </div> 
              </div>

              <div
                v-else
                class="d-flex py-6 px-8 justify-center" 
                style="width: 100%"
              >
                <div class="mx-4 d-flex">
                  <div 
                    class="d-flex align-center" 
                    :style="{
                      'margin-left': (dollarByPeriod.dollar_trend.toLocaleLowerCase().includes('neutral') && isPtBRLocale === true) ||
                        (dollarByPeriod.dollar_trend.toLocaleLowerCase().includes('sell') && isPtBRLocale === true)
                        ? '-52px' : '-82px'
                    }"
                  >
                    <v-icon style="font-size: 58px" color="primary">
                      {{ dollarByPeriod.dollar_trend | trendIcon }}
                    </v-icon>
                    &nbsp;
                    <div 
                      class="text-h4 font-weight-bold" 
                      :style="{
                        'margin': (dollarByPeriod.dollar_trend.toLocaleLowerCase().includes('neutral') ||
                          (dollarByPeriod.dollar_trend.toLocaleLowerCase().includes('sell') && isPtBRLocale === true))
                        ? '0 10px' : '0px 46.5px 0px 23.5px'
                      }"
                    >
                    {{ trendLabel(dollarByPeriod.dollar_trend) }}
                    </div>
                    <div class="ml-4 d-flex flex-column text-body-1 text--secondary"> 
                      <span> {{ $t('marketMonitor.dollar') }} </span>
                      <span class="font-weight-bold">
                        {{ $t('marketMonitor.trend') }}
                      </span> 
                    </div>
                  </div>
                </div>
              </div>

              <!-- Dollar Target -->
              <div class="d-flex pb-6 pt-0 px-8 align-center justify-center" style="width: 100%">
                <div class="mx-4 d-flex flex-column">
                  <div class="d-flex justify-center text-body-1 text--secondary"> 
                      <span> {{ $t('marketMonitor.dollar') }} </span>&nbsp;
                      <span class="font-weight-bold"> 
                        {{ $t('marketMonitor.target') }} 
                      </span> 
                  </div>
                  <div class="d-flex align-center" style="margin-left: -82px">
                    <v-icon style="font-size: 58px" color="#424242">
                      mdi-bullseye
                    </v-icon>
                    &nbsp;
                    <div class="text-h4 ml-4 font-weight-bold">
                      {{ dollarByPeriod.dollar_target }}
                    </div>
                    </div>
                </div>
              </div>
              <div class="px-8" style="width: 100%">
                <v-divider></v-divider>
              </div>
              <div 
                class="d-flex justify-center py-9 text-h4 font-weight-bold"
                style="width: 100%; flex-wrap: wrap"
              >
                <span style="text-wrap: nowrap">{{ $t('marketMonitor.goodTo') }}</span> 
                <span 
                  v-for="(part, index) in bestChoice(dollarByPeriod).parts" 
                  :key="index" 
                  :class="part.class"
                >
                  &nbsp;{{ part.text }}
                </span>
              </div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
      <!-- end of Dollar Radar -->

      <v-divider v-if="false" vertical class="d-none d-lg-flex"></v-divider>
      
      <!--col 1-->
      <v-col
        xs="8"
        sm="8"
        md="8"
        lg="8"
        xl="8"
      >
        <!--news (top col-1)-->
        <div class="news-chart"
        >
          <div class="text-body text-center font-weight-bold">
            <span
            :style="{ '--news-font-size': fontsSetting.getFontSize * '12' + 'px' }"
             class="font-size-title">{{ $t('marketMonitor.news') }}</span>
          </div> 

          <!--loading on news-->
          <div
            v-if="!getFxMarketNews"
            class="loading-indicator d-flex justify-center align-center  flex-gow-1"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              :size="50"
              :width="5"
            >
            </v-progress-circular>
            <span class="ml-3 text-h4">{{ $t('extras.loadingDot') }} </span>
          </div>


          <div class=" grow over " style="overflow-y: hidden; height: 23vh;" v-if="getFxMarketNews">
            <news-chart :slides="getFxMarketNews"></news-chart>
          </div>
          <ViewMore @open="openNews"/>
        </div>
      </v-col>
      <!--currency pair (bottom col-2)-->
      <v-col md="4" sm="4" lg="4" xs="4">
        <div class=" p-chart mx-5"> 
          <div class="text-body text-center font-weight-bold"> 
            <span
            :style="{ '--news-font-size': fontsSetting.getFontSize * '12' + 'px' }" 
            class="font-size-title">{{ $t('marketMonitor.currencyPair') }}</span>
          </div> 
            <!--pills-->
          <div
            v-if="sparklineDataIntraday?.filteredData || sparklineDataDaily"
            class=" text-caption font-weight-black d-flex justify-center"
          > 
            <v-chip-group v-model="selectedChart" mandatory @change="filterData(currentFilter)" show-arrows >
              <v-chip
                v-for="(chartName, index) in chartNames"
                color="#212121"
                text-color="#BDBDBD"
                active-class="primaryTransp primary--text"
                :key="index"
                :value="chartName"
                x-small
              >
                {{ chartName }}
              </v-chip> 
            </v-chip-group>                
          </div> 
          
          <div
            v-if="!sparkline"
            class="loading-indicator d-flex justify-center align-center  flex-gow-1"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              :size="50"
              :width="5"
            >
            </v-progress-circular>
            <span class="ml-3 text-h4">{{ $t('extras.loadingDot') }} </span>
          </div>         

          <div
            v-if="sparkline"
            class="d-flex justify-center flex-column"
            style="overflow-y: auto;"
          >
            <v-chart
              :option="sparkline"
              class="chart"
              autoresize
              style="height: 18vh"
              ref="chart"
            ></v-chart>

              <div v-if="sparklineDataIntraday?.filteredData || sparklineDataDaily" class="my-3 d-flex justify-center align-center">
                <v-btn-toggle v-model="currentFilter" mandatory @change="filterData(currentFilter)">
                  <v-btn x-small :disabled="isWeekendOrHoliday" value="day" class="mb-1">{{ $t('timestamp.oneDay') }}</v-btn>
                  <v-btn x-small value="week">{{ $t('timestamp.oneWeek') }}</v-btn>
                  <v-btn x-small value="month" :disabled="!sparklineDataDaily">{{ $t('timestamp.oneMonth') }}</v-btn>
                </v-btn-toggle>
              </div>

            <div class="difference-values text-center text-caption">
              <p class="font-size-title">
                {{ differenceInValuesChart.firstValue.time }} - {{ differenceInValuesChart.lastValue.time }}
              </p>
              <p class="mb-3 font-size-title">
                {{ $t('marketMonitor.priceVariation') }}: 
                <span
                  class="font-size-title"
                  :style="differenceInValuesChart.totalDifference.absolute.toFixed(4) < 0
                    ? { color:'#FF6D00'} : {color:'#00c853'}"
                >
                  {{ differenceInValuesChart.totalDifference.absolute.toFixed(4) }}
                  ({{ differenceInValuesChart.totalDifference.percentage.toFixed(2) }}%)
                </span> 
              </p>
            </div>
          </div>

         
          <!--weekend / holiday notice -->
          <div class="d-flex justify-center">
            <div
              v-if="sparklineDataIntraday?.filteredData && sparklineDataDaily && isWeekendOrHoliday && currentFilter === 'day' "
              style="position: relative; display: flex; align-items: center; max-width: 400px"
            >
              <span
                class="text--disabled font-weight-light text-center"
                :style="{
                  'font-size': '10px',
                  left: '80px',
                  top: '5px'
                }"
              >
                {{ $t('marketMonitor.chartHoliday') }}
              </span>
            </div>
          </div>
          <ViewMore  @open="openCurrencyPair"/>
        </div>
      </v-col>

    </v-row>
    <div class="border-calendar"></div>
    <v-row>
      <v-col
        xs="8"
        sm="8"
        md="8"
        lg="8"
        xl="8"
        class="mt-2 px-0"
      >
          <!--economic calendar (bottom col-1)-->
            <div class="economic-calendar">
              <div class="text-body text-center font-weight-bold pb-2 ">
                <span
                :style="{ '--news-font-size': fontsSetting.getFontSize * '12' + 'px' }" 
                class="font-size-title"> {{ $t('marketMonitor.economicCalendar') }} </span>
              </div>
              <div
                class="flex-grow-1 d-flex"
                style="overflow-y: hidden;
                height:35vh;"
                v-if="getFxMarketEconomicCalendar"
              >
                <economic-calendar-chart class="mx-7" style="width:100%;">
                </economic-calendar-chart>
              </div>
            <ViewMore @open="openCalendar"/>
          </div>
    </v-col>
      <!--col 2-->
      <v-col md="4" sm="4" lg="4" xs="4">
        <!--cross quotes (top col-2)-->
        <div class="cross-quotes mx-3 pt-2" 
        >
          <div class="text-body text-center font-weight-bold">
            <span
            :style="{ '--news-font-size': fontsSetting.getFontSize * '12' + 'px' }" 
            class="font-size-title"> {{ $t('marketMonitor.crossQuotes') }} </span>
          </div>
          <div>
            <cross-quote-table></cross-quote-table>
          </div>
          <ViewMore @open="openCrossQuotes"/> 
        </div>
      </v-col>
    </v-row>

    <!-- chart modal -->
    <InfoModal v-model="showModal" :marketData="modalData" >
      <!--modal currency pair-->
      <template #default>
        <!--pills-->
        <div
          v-if="sparklineDataIntraday?.filteredData || sparklineDataDaily"
          class="text-caption font-weight-black d-flex justify-center"
        >
          <v-chip-group
            v-model="selectedChart"
            mandatory
            @change="filterData(currentFilter)"
            show-arrows
          >
            <v-chip
              color="#212121"
              text-color="#BDBDBD"
              active-class="primaryTransp primary--text"
              v-for="(chartName, index) in chartNames"
              :key="index"
              :value="chartName"
              medium
            >
              {{ chartName }}
            </v-chip>
          </v-chip-group>
        </div>
        <!--pills END-->

        <div
          v-if="!sparkline"
          class="loading-indicator d-flex justify-center align-center flex-grow-1"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            :size="110"
            :width="7"
          ></v-progress-circular>
          <span class="ml-3 text-h4">{{ $t("extras.loadingDot") }} </span>
        </div>
        <div
          v-if="sparkline"
          class="d-flex justify-center"
          style="max-height: 500px; overflow-x: hidden; overflow-y: auto"
        >
          <v-chart
            :option="sparkline"
            class="chart"
            autoresize
            style="height: 60vh"
            ref="chart"
          ></v-chart>
        </div>

        <!-- Weekend/Holiday notice -->
        <div class="d-flex justify-center">
          <div
            v-if="
              sparklineDataIntraday?.filteredData &&
              sparklineDataDaily &&
              isWeekendOrHoliday &&
              currentFilter === 'day'
            "
            style="
              position: relative;
              display: flex;
              align-items: center;
              max-width: 200px;
            "
          >
            <span
              class="text--disabled font-weight-light"
              :style="{
                'font-size': '12px',
                left: '80px',
                top: '5px',
              }"
            >
              We don't have 1D data during weekends or holidays, so this data is
              from the last business day.
            </span>
          </div>

          <!-- 1D/1W/1M Filter Buttons -->
          <div 
          style="display:none;"
            v-if="sparklineDataIntraday?.filteredData || sparklineDataDaily"
          >
            <v-btn-toggle
              v-model="currentFilter"
              mandatory
              @change="filterData(currentFilter)"
            >
              <v-btn 
                small value="day"
                :disabled="selectedChart !== 'USD/BRL'"
              >
                {{ $t("timestamp.oneDay") }}
              </v-btn>

              <v-btn
                small
                value="week"
              >
                {{ $t("timestamp.oneWeek") }}
              </v-btn>

              <v-btn
                small value="month"
                :disabled="!sparklineDataDaily"
              >
                {{ $t("timestamp.oneMonth") }}
              </v-btn>
            </v-btn-toggle>
          </div>
        </div>
      </template>
    </InfoModal>
    <!--chart modal END-->

  </v-container>
</template>

<script>
import { mapState, mapActions } from "pinia"
import { useFxMarketStore } from "@/store/toolbarStore"
import { useColorsStore, useSettingsStore } from "../store/index"
import * as utils from "../utils.js"
import NewsChart from "../components/NewsChart.vue"
import CrossQuoteTable from "../components/CrossQuoteTable.vue"
import EconomicCalendarChart from "../components/EconomicCalendarCharts.vue"
import VChart from "vue-echarts"
import * as echarts from 'echarts';
import { use } from 'echarts/core'
import { LineChart } from 'echarts/charts'
import {
  TooltipComponent,
  TitleComponent,
  ToolboxComponent,
  GridComponent,
  DataZoomComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import InfoModal from "@/components/modal/InfoModal.vue"
import ViewMore from "@/components/common/ViewMore.vue"

use([
  TooltipComponent,
  TitleComponent,
  ToolboxComponent,
  GridComponent,
  DataZoomComponent,
  LineChart,
  CanvasRenderer
])

export default {
  filters: {
    trendIcon (value) {
      const trends = {
        STRONG_SELL: "mdi-trending-down",
        STRONG_BUY: "mdi-trending-up",
        BUY: "mdi-trending-up",
        SELL: "mdi-trending-down",
        NEUTRAL: "mdi-trending-neutral"
      }
      return trends[value]
    }
  },
  data() {
    return {
      vh:window.innerHeight,
      fontsSetting: useSettingsStore(),
      firstPoint:{x:"", y:""},
      secondPoint:{x:"", y:""},
      togglePositionData: true,
      showModal:false,
      modalData: {title:"", component:null, content:{}},
      chartData: null,
      eventSource: undefined,
      interval: null,
      currentWeekStart: null,
      filteredSparklineData: [],
      min: null,
      max: null,
      lastTimeStap:null,
      chartInstance: null,
      currentFilter: 'day',
      selectedChart: 'USD/BRL',
      dollar: {
        "W": {
          "dollar_today": "-",
          "dollar_trend": "-",
          "dollar_target": "-",
          "dollar_best_choice": "-"
        },
        "10D": {
          "dollar_today": "-",
          "dollar_trend": "-",
          "dollar_target": "-",
          "dollar_best_choice": "-"
        },
        "20D": {
          "dollar_today": "-",
          "dollar_trend": "-",
          "dollar_target": "-",
          "dollar_best_choice": "-"
        },
        "1M": {
          "dollar_today": "-",
          "dollar_trend": "-",
          "dollar_target": "-",
          "dollar_best_choice": "-"
        },
      },
      selectedDollarPeriod: { value: "W" },
      loadingFetchDollar: false,
      intervalDaily: null,
      timeoutDaily: null,
      holidaysList: [],
      chartKey: 0,
      chartReloadInterval: null,
      dayOff: false,
      intradayChart: null,
      intradayChartInterval: null,
    }
  },
  components: {
    VChart,
    NewsChart,
    CrossQuoteTable,
    EconomicCalendarChart,
    ViewMore,
    InfoModal
  },
  computed: {
    ...mapState(useColorsStore, [
      "orangeColor",
      "aliveColor",
    ]),
    ...mapState(useFxMarketStore, [
      "getFxMarketEconomicCalendar",
      "getFxMarketNews",
      "getFxMarketDailyData",
      "getFxMarketIsLoading"
    ]),
    now () {
      return utils.formatTimeAndDate()
    },
    sparklineDataDaily() {
      if (!this.fxMarketDailyDataData || Object.keys(this.fxMarketDailyDataData).length === 0) {
        return
      }

      let selectedChart = this.selectedChart
      if (this.selectedChart === undefined) {
        selectedChart = this.chartNames[0]
      }

      const selectedSparkline = this.fxMarketDailyDataData[selectedChart]

      const today = new Date()
      const oneMonthAgo = new Date()
      oneMonthAgo.setDate(today.getDate() - 31)

      const filteredDataMonth = []

      for (const key in selectedSparkline) {
        const dateBrl = new Date(key).getTime() + (3 * 60 * 60 * 1000)

        if (dateBrl >= oneMonthAgo.getTime() &&
          dateBrl <= today.getTime() &&
          !this.isHoliday(new Date(dateBrl))) {
            filteredDataMonth.push({
              timestamp: dateBrl,
              value: selectedSparkline[key]['1. open'],
            })
          }
        }

      filteredDataMonth.reverse()
      return {
        filteredDataMonth,
      }
    },
    sparklineDataIntraday() {
      if (!this.fxMarketIntradayDataData || Object.keys(this.fxMarketIntradayDataData).length === 0 || !this.chartNames) {
        return {}
      }

      let selectedChart = this.selectedChart
      if (this.selectedChart === undefined) {
        selectedChart = this.chartNames[0]
      }

      const selectedSparkline = this.fxMarketIntradayDataData[selectedChart]
      // Right after a pair switch the loaded bars are still the previous pair's.
      // Returning no lists, rather than empty ones, keeps filterData() from
      // taking the day as empty and moving to the week view.
      if (!selectedSparkline) {
        return {}
      }
      
      const today = new Date()
      const currentDay = today.getDay()
      const currentHour = today.getHours()
      const oneWeekAgo = new Date()
      oneWeekAgo.setDate(today.getDate() - 7)

      let startOfDayBRT, endOfDayBRT

      if (currentHour < 9 || this.isWeekendOrHoliday) {
        const yesterday = new Date(today)
        if (currentDay === 0) {
          yesterday.setDate(today.getDate() - 2)
        } else {
          yesterday.setDate(today.getDate() - 1)
        }
        while (this.isHoliday(yesterday) || yesterday.getDay() === 0 || yesterday.getDay() === 6) {
          yesterday.setDate(yesterday.getDate() - 1)
        }

        startOfDayBRT = new Date(yesterday.setHours(9, 0, 0, 0)).getTime()
        endOfDayBRT = new Date(yesterday.setHours(18, 30, 0, 0)).getTime()
      } else {
        startOfDayBRT = new Date(today.setHours(9, 0, 0, 0)).getTime()
        endOfDayBRT = new Date(today.setHours(18, 30, 0, 0)).getTime()
      }

      const filteredData = []
      const filteredDataWeek = []

      for (const key in selectedSparkline) {
        const dateUtc = new Date(key).getTime()
        const dateBrl = dateUtc - (3 * 60 * 60 * 1000)
        const dateBrlDate = new Date(dateBrl)
        const dayOfWeek = dateBrlDate.getDay()
        const hourOfDay = dateBrlDate.getHours()
        const minutesOfHour = dateBrlDate.getMinutes()

        if (dateBrl >= startOfDayBRT && dateBrl <= endOfDayBRT) {
          filteredData.push({
            timestamp: dateBrl,
            value: selectedSparkline[key]['4. close'],
          })
        }
        
        if (dateBrl >= oneWeekAgo.getTime() &&
          dateBrl <= today.getTime() &&
          dayOfWeek > 0 && dayOfWeek < 6 &&
          !this.isHoliday(new Date(dateBrl)) &&
          (hourOfDay >= 9 && hourOfDay < 18 || (hourOfDay === 18 && minutesOfHour <= 30))) {
          filteredDataWeek.push({
            timestamp: dateBrl,
            value: selectedSparkline[key]['4. close'],
            })
          }
        }

      filteredData.reverse()
      filteredDataWeek.reverse()

      return {
        filteredData,
        filteredDataWeek,
      }
    },
    minMax() {
      if (!this.filteredSparklineData) {
        return { min: 0, max: 0 }
      }
      const values = this.filteredSparklineData.map(point => parseFloat(point.value))
      const min = Math.min(...values)
      const max = Math.max(...values)
      const interval = (max - min)
      const adjustedMin = parseFloat(Math.max(min - (interval * 1.1), 0)).toFixed(4)
      const adjustedMax = parseFloat(max + (interval * 1.1)).toFixed(4)
      return { min: adjustedMin, max: adjustedMax }
    },
    // xAxisData() {
    //   return this.filteredSparklineData.map(dataPoint => {
    //     const date = new Date(dataPoint.timestamp)
    //     if (this.currentFilter === 'day') {
    //       return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
    //     } else {
    //       return date.getDate()
    //     }
    //   })
    // },
    xAxisInterval() {
      const dataLength = this.filteredSparklineData.length
      const startTime = this.filteredSparklineData[0].timestamp
      const endTime = this.filteredSparklineData[dataLength - 1].timestamp
      const timeSpan = endTime - startTime
      let minInterval

      switch (this.currentFilter) {
        case 'day':
          if (timeSpan <= 60 * 60 * 1000) {
            minInterval = 5 * 60 * 1000
          } else if (timeSpan <= 4 * 60 * 60 * 1000) {
            minInterval = 10 * 60 * 1000
          } else {
            minInterval = 30 * 60 * 1000
          }
          return minInterval
        // case 'week':
        //   minInterval = 24 * 60 * 60 * 1000
        //   return minInterval
        case 'month':
          minInterval = 24 * 60 * 60 * 1000
          return minInterval
        default:
          return 0
      }
    },
    differenceInValuesChart(){
      if (!this.filteredSparklineData || this.filteredSparklineData.length === 0) return
      const options = JSON.parse(JSON.stringify(this.sparklinesOptions))

      const categories = this.filteredSparklineData.map(dataPoint =>
        this.formatDate(dataPoint.timestamp, this.currentFilter)
      )
      const values = this.filteredSparklineData.map(dataPoint => parseFloat(dataPoint.value))
      const firstValue = {time: categories[0], val: values[0]} 
      const lastValue = {time: categories[categories.length-1], val: values[values.length-1]}
      const totalDifference = {
        absolute: lastValue.val - firstValue.val,
        percentage: ((lastValue.val - firstValue.val) / firstValue.val) * 100
      }
      return {
        firstValue,
        lastValue,
        totalDifference
      }

    },
    sparkline() {
      if (!this.filteredSparklineData || this.filteredSparklineData.length === 0) return
      const options = JSON.parse(JSON.stringify(this.sparklinesOptions));

      const categories = this.filteredSparklineData.map(dataPoint =>
        this.formatDate(dataPoint.timestamp, this.currentFilter)
      )
      const values = this.filteredSparklineData.map(dataPoint => parseFloat(dataPoint.value))

      options.xAxis.data = categories
      options.series[0].data = values

        this.renderChartLastValue(options, values);
      if (this.currentFilter === 'week') {
        let lastDay = '';
        // const lastIndex = categories.length - 1

        // options.xAxis.axisLabel.formatter = (value, index) => {
        options.xAxis.axisLabel.formatter = (value) => {
          const currentDay = value.split(' ')[0]

          // if (currentDay !== lastDay || index === lastIndex) {
          if (currentDay !== lastDay) {
            lastDay = currentDay
            return currentDay
          }

          return ''
        }
      }

      options.tooltip.formatter = (params) => {
        const dataPoint = params[0]
        const rawTimestamp = this.filteredSparklineData[dataPoint.dataIndex]?.timestamp
        const formattedDate = this.formatDate(rawTimestamp, this.currentFilter, true, true)
        const value = dataPoint.value;
        const v1= this.filteredSparklineData[this.firstPoint.x]?.value
        const v2= this.filteredSparklineData[this.secondPoint.x]?.value
        const differencePos = (v2 - v1).toFixed(3);
        const differencePercent = (differencePos/v1 * 100).toFixed(3);
        //#FF6D00 -> -
        //#00c853 -> +
        return `
          ${formattedDate}
        <br>${dataPoint.marker} 
        ${dataPoint.seriesName}: 
        <b> ${value} `
      }

      options.axisPointer = {
            label: {
              backgroundColor: '#777',
              formatter: (params) => categories[params.value]
            }
          }
          
      return options
    },
    sparklinesOptions() {
      const scale = {
        fontScale : this.fontsSetting.getFontSize,
        gridMargin: this.fontsSetting.fontsize === 'SM' ? 50 : this.fontsSetting.fontsize === 'MD'  ? 60 : 65,
        splitNumber : this.vh < 700 ? 2 : this.vh < 1000 ? 4 : 7
      }
      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            snap: true,
          },
        },
        grid: {
          top: 10,
          bottom:25,
          left:scale.gridMargin,
          right:scale.gridMargin,
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: [],
          axisLabel: {
            fontSize: Math.round(11 * scale.fontScale),
            showMinLabel: true,
            showMaxLabel: true,
            interval: 8,
          },
          axisLine: { show: true },
          axisTick: { 
            show: true,
            alignWithLabel: true
          },
        },
        yAxis: [
          {
            type: "value",
            ...this.minMax,
            splitNumber: scale.splitNumber,
            splitLine: { show: false },
            opacity:0,
            position: 'left',
            axisLabel: {
              fontSize: Math.round(11 * scale.fontScale),
            }
          },
          {
            type: 'value',
            ...this.minMax,
            splitNumber: scale.splitNumber,
            splitLine: { show: false },
            position: 'right',
            axisLabel: {
              fontSize: Math.round(11 * scale.fontScale),
              formatter:(value)=>Number(value).toFixed(4)
            }
          },
        ],
        series: [
          {
            name: 'Data',
            type: 'line',
            symbol: "circle",
            sampling: 'lttb',
            yAxisIndex:1,
            itemStyle: {
              color: this.changeValue > 0 ? this.aliveColor : this.orangeColor,
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: this.changeValue > 0 ? this.aliveColor : this.orangeColor,
                  },
                  {
                    offset: 1,
                    color: 'rgba(0, 0, 0, 0)',
                  },
                ],
              },
            },
            data: []
          },
        ],
      }
    },
    changeValue() {
      const data = this.filteredSparklineData
      const length = data.length
      const last = data[length - 1].value
      const first = data[0].value
      const result = last - first
      return Number(result.toFixed(6))
    },
    chartNames () {
      if (!this.getfxMarketDailyData && !this.intradayChart) return []
      return this.getfxMarketDailyData
        ? this.getfxMarketDailyData.tickers
        : this.intradayChart.tickers
    },
    dollarByPeriod () {
      return this.dollar[this.selectedDollarPeriod.value]
    },
    outOfWeek () {
      const timeZone = utils.getTimeZone()

      const today = new Date()

      const weekday = new Intl.DateTimeFormat('en-US', {
        timeZone,
        weekday: 'short'
      }).format(today)

      const dayIndexMap = {
        Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6
      }

      const dayOfWeek = dayIndexMap[weekday] ?? -1

      return dayOfWeek > 3
      // const dayOfWeek = new Date().getDay()
      // if (dayOfWeek > 3) {
      //   return true
      // }
      // return false
    },
    dollarPeriods () {
      return [
        { text: this.$t('marketMonitor.period.endWeek'), value: "W" },
        { text: this.$t('marketMonitor.period.tenDays'), value: "10D" },
        { text: this.$t('marketMonitor.period.twentyDays'), value: "20D" },
        { text: this.$t('marketMonitor.period.oneMonth'), value: "1M" }
      ]
    },
    isPtBRLocale() {
      return this.$i18n.locale === "pt"
    },
    fxMarketDailyDataData () {
      if (!this.getFxMarketDailyData) return []
      return this.getFxMarketDailyData.data
    },
    fxMarketIntradayDataData () {
      if (!this.intradayChart) return []
      return this.intradayChart.data
    },
    isWeekendOrHoliday() {
      const { year, month, day } = utils.getDateParts(new Date())
      const dateStr = `${year}-${month}-${day}`

      const weekday = new Intl.DateTimeFormat('en-US', {
        timeZone: utils.getTimeZone(),
        weekday: 'short'
      }).format(new Date())

      const isWeekend = weekday === 'Sat' || weekday === 'Sun'
      const isHoliday = this.holidaysList.some(h => h.date === dateStr)

      return isWeekend || isHoliday

      // const currentDay = today.getDay()
      // const todayDate = today.toISOString().split('T')[0]
      
      // if (currentDay === 0 || currentDay === 6) {
      //   return true
      // }
      
      // for (let holiday of this.holidaysList) {
      //   if (holiday.date === todayDate) {
      //     return true
      //   }
      // }
      // return false
    }
  },
  watch: {
    currentFilter(newVal) {
      this.handleChartReloadInterval(newVal)
    },
    selectedChart() {
      this.fetchIntradayChart()
    },
    chartKey(){
      this.$nextTick(() => {
        const chart = this.$refs.chart
        if (!chart) return

        chart.chart.getZr().off("click")
        chart.chart.getZr().on('click', e => {
          const [x, y] =  [e.offsetX, e.offsetY]

          const dataCoord=  chart.convertFromPixel({ seriesIndex: 0 },[x,y])

          if(this.togglePositionData){
            this.firstPoint = {x: dataCoord[0],y: dataCoord[1]}
          }
          else{
            this.secondPoint = {x: dataCoord[0],y: dataCoord[1]}
          }
          this.togglePositionData = !this.togglePositionData  
          
        })
      })
    },


  },
  mounted() {
    this.fixComponentPositions()
    window.addEventListener("resize", this.fixComponentPositions)
    if (this.outOfWeek) {
      this.selectedDollarPeriod = this.dollarPeriods.filter(x => x.value === "10D")[0]
      const index = this.dollarPeriods.map(x => x.value).indexOf("W")
      this.dollarPeriods[index]["disabled"] = true
    }
    this.fetchHolidaysList()
    this.fetchDollarRadar()
    this.fetchIntradayChart()
    this.intradayChartInterval = setInterval(this.fetchIntradayChart, 60000)
    this.waitForSparkline()
    this.lastTimeStap = setInterval(()=>{
      this.filterData(this.currentFilter);
      this.renderChart()
    }, 6000)
    //this.handleChartReloadInterval(this.currentFilter)
  },
  beforeDestroy () {
    this.fixComponentPositions()
    clearInterval(this.intervalDaily)
    clearInterval(this.lastTimeStap)
    clearInterval(this.chartReloadInterval)
    clearInterval(this.intradayChartInterval)
    clearTimeout(this.timeoutDaily)
  },
  methods: {
    // modal window
    openNews()
{
  const settingsStore = useSettingsStore();
  this.modalData={
    title:"News",
    component: NewsChart,
    content:{slides: this.getFxMarketNews, fontSize:17}
  }
  this.showModal = true
  settingsStore.isModalOn = true

},

//resizing
fixComponentPositions()
{
    this.vh=window.innerHeight;
},
openCalendar(){
  const settingsStore = useSettingsStore();
this.modalData={
  title:"Economic Calendar",
  component:EconomicCalendarChart,
  content:{slides:this.getFxMarketNews, fontSize:"clamp(0.45rem, 1vw, 1rem)"}
}
this.showModal=true
settingsStore.isModalOn = true
},
openCrossQuotes(){
this.modalData={
  title:"Cross Quotes",
  component:CrossQuoteTable,
  content:{imgSize:50, fontSize:20}
}
this.showModal=true
},

openCurrencyPair(){
this.modalData={
  title:"Currency Pair",
  component:null,
  content:{
    option:this.sparkline,
    autoresize:true,
    style:"width:100%, height:80vh, minHeight:70vh"
    
  }
}
this.showModal=true
},


/**modals type END */


    ...mapActions(useFxMarketStore, [
      "getDollarRadar",
      "getHolidaysList"
    ]),
    // listenFeed() {
    //   const sparklinesEvent = "sparklines"
    //   const url = `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/feed`
    //   this.eventSource = new EventSource(`${url}`)
    //   this.eventSource.addEventListener(sparklinesEvent, event => {
    //     const data = JSON.parse(event.data)
    //     this.sparklineList = data
    //     this.filterData(this.currentFilter)
    //   })
    // },
    renderChart(){
      if(!this.chartInstance || !this.filteredSparklineData?.length) return
      const categories = this.filteredSparklineData.map(p=>this.formatDate(p.timestamp, this.currentFilter))
      const values = this.filteredSparklineData.map(p=>Number(p.value));

      const options = {
          xAxis: { data: categories },
          series: [
            {
              id: 'main',
              type: 'line',
              data: values,
            }
          ]
        };
        this.renderChartLastValue(options, values);
        this.chartInstance.appendData({
          seriesIndex: 0,
          data: [[last.timestamp, newValue]]
        })
    },
    renderChartLastValue(options, values) {
      let dataLength = options.series[0].data
      let finalIndex = dataLength.length - 1
      options.series[0].data = values.map((v,idx)=>{
        if (idx === finalIndex)
        {
          return {
            value:v,
            symbol:"circle",
            symbolSize: 7
          }
        }
        return {
            value:v,
            symbol:"none",
          }
      })
      const lastVal = values[values.length-1]; 

      options.series[0].markLine = {
      silent: true,
      symbol: "none",
        //#FF6D00 -> -
        //#00c853 -> +
      data: [{
        yAxis: lastVal.toFixed(4),
        label: {
          show: true,
          distance: 5,
          formatter: lastVal.toFixed(4),
          borderWidth: 1,
          borderColor:  this.differenceInValuesChart.totalDifference.absolute.toFixed(4) < 0 ? '#FF6D00' : '#00c853',
          backgroundColor:  'none',
          color: this.differenceInValuesChart.totalDifference.absolute.toFixed(4) < 0 ? '#FF6D00' : '#00c853',
          padding: [2, 6],
          borderRadius: 4
        },
      }]
    };

    const lastIndex = values.length - 1;
    const lastCategory = options.xAxis.data[lastIndex];
    const lastValue = values[lastIndex];

    options.series[1] = {
        type: "effectScatter",
        coordinateSystem: "cartesian2d",
        z: 10,
        data: [[lastCategory, lastValue]],
        symbolSize: 5,
        rippleEffect: {
          scale: 7,
          brushType: "stroke",
        },
        itemStyle: {
          color:
            this.differenceInValuesChart.totalDifference.absolute < 0
              ? "#FF6D00"
              : "#00c853",
        },
        showEffectOn: "render",
        animationDuration: 0,
        animationDurationUpdate: 0,
      };
    },
    fetchIntradayChart() {
      // Only the selected pair's week is fetched here; the toolbar polling
      // keeps just the newest bar of each pair.
      const pair = this.selectedChart
      useFxMarketStore().getFxMarketIntraday(pair, 7)
        .then((response) => {
          // The pair can change while the request is out; a late answer for the
          // previous pair must not replace the selected pair's bars.
          if (pair !== this.selectedChart) return
          this.intradayChart = response.data
          this.filterData(this.currentFilter)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    filterData(period) {
      //if (this.selectedChart !== 'USD/BRL' && period === 'day') {
       // period = 'week'
     // }
      
      const monthData = this.sparklineDataDaily
      const data = this.sparklineDataIntraday

      this.currentFilter = period

      if (period === 'day') {
        if(data['filteredData']?.length === 0 )
        {
          this.currentFilter = 'week'
          this.filteredSparklineData = data['filteredDataWeek']
        }
        else
        {
          this.filteredSparklineData = data['filteredData']
        }
      } else if (period === 'month') {
        this.filteredSparklineData = monthData['filteredDataMonth']
      } else {
        this.filteredSparklineData = data['filteredDataWeek']
      }
    },
    fetchDollarRadar() {
      this.loadingFetchDollar = true
      this.getDollarRadar()
        .then((response) => {
          const data = response.data
          this.dollar = data
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.loadingFetchDollar = false
        })
    },
    trendLabel (value) {
      const trends = {
        STRONG_SELL: this.$t('marketMonitor.dollarRadar.strongSell'),
        STRONG_BUY: this.$t('marketMonitor.dollarRadar.strongBuy'),
        BUY: this.$t('marketMonitor.dollarRadar.buy'),
        SELL: this.$t('marketMonitor.dollarRadar.sell'),
        NEUTRAL: this.$t('marketMonitor.dollarRadar.neutral')
      }
      return trends[value]
    },
    bestChoice(dollarPeriod) {
      if (dollarPeriod.dollar_best_choice === 'SELL') {
        return {
          parts: [
            { text: this.$i18n.t('side.sell').toUpperCase(), class: 'orangeColor--text' }
          ]
        }
      }
      else if (dollarPeriod.dollar_best_choice === 'BUYSELL') {
        return {
          parts: [
            { text: this.$t('quoteInfo.buy').toUpperCase(), class: 'alive--text' },
            { text: this.$t('extras.or'), class: '' },
            { text: this.$t('quoteInfo.sell').toUpperCase(), class: 'orangeColor--text' }
          ]
        }
      }
      else {
        return {
          parts: [
            { text: this.$t('quoteInfo.buy').toUpperCase(), class: 'alive--text' }
          ]
        }
      }
    },
    formatDate(value, filter, forTooltip = false) {
      const { year, month, day, hour, minute } = utils.getDateParts(value, true)

      const labelDate = [day, month]
      const labelHour = [hour, minute]
      const labelYear = year

      if (forTooltip) {
        if (filter === 'day' || filter === 'week') {
          return `
          ${labelYear}-${labelDate.join('-')} <br>
          ${labelHour.join(':')}
          `
        }
        if (filter === 'month') {
          return `${labelYear}-${labelDate.join('-')}`
        }
      }

      if (filter === 'day') {
        return labelHour.join(':')
      } else {
        return labelDate.join('/')
      }
    },
    fetchHolidaysList() {
      this.getHolidaysList()
        .then((response) => {
          this.holidaysList.push(...response.holidays)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    isHoliday (date) {
      if (!this.holidaysList || this.holidaysList.length === 0) return false
      const formattedDate = date.toISOString().split('T')[0]
      return this.holidaysList.some(holiday => holiday.date === formattedDate)
    },
    handleChartReloadInterval(filter) {
      if (this.chartReloadInterval) {
        clearInterval(this.chartReloadInterval)
        this.chartReloadInterval = null
      }

      if (filter === 'day' || filter === 'week') {
        this.chartReloadInterval = setInterval(() => {
          this.chartKey += 1
        }, 25000)
      }
    },
    waitForSparkline(attempts = 0, maxAttempts = 20) {
      if(attempts === 0) {
        this.filterData(this.currentFilter)
      }

      if (this.sparkline) {
        this.renderChart()
      } else if (attempts < maxAttempts) {
        setTimeout(() => this.waitForSparkline(attempts + 1, maxAttempts), 3000)
      }
    }
  }
}
</script>

<style scoped>
.market-container {
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap:.2rem;
  height:100% !important;
}
.difference-values
{
  padding-top:.5rem;
  line-height:.15rem;
}
.view-more {
  display:flex;
}
.font-size-title{
  font-size: var(--news-font-size) !important;
}
/*
.news-chart, .cross-quotes{
  height:30%;
}
.p-chart, .economic-calendar{
  height:55%;
}

*/
.economic-calendar, .p-chart, .cross-quotes, .news-chart {
 
  display: flex;
  justify-content: space-between;
  flex-direction: column;
 height:100% !important;
}

.bottom-border{
 border-bottom:1px solid #3d3d3d;
}

.border-calendar{
  position:fixed;
  right: 33%;
  top:0%;
  height:100%;
  border-right: 1px solid #3d3d3d;

}

.ui-row {
  min-height: 0;
  flex: 1 1 25vh;
  height: 27vh;
}
.ui-row:first-of-type {
  flex: 0.5 1 50%;
}

.ui-row:last-of-type {
  flex: 1.5 1 50%;
}
.ui-col {
  flex: 1 1 50% !important;
  display: flex;
  flex-direction: column;
}
  .chart {
    max-width: 1940px;
    /* width: 1940px; */
    width: 100%;
    box-sizing: border-box;
    overflow: hidden
  }

.disable-focus:focus::before {
  opacity: 0 !important
}
</style>
